<script setup lang="ts">
    import { useLoadingStore } from '@/stores/loading.store';
    import { storeToRefs } from 'pinia';
    import { ref } from 'vue'

    const appSidebarOpened = ref(true);
    const appNavigationOpened = ref(false);
    function toggleAppNavigation(isOpen: boolean) { appNavigationOpened.value = isOpen; }
    function onAppSidebarToggled(sidebarState: boolean) { appSidebarOpened.value = sidebarState; }
    const loading = useLoadingStore();
    const { isLoading } = storeToRefs(loading);
</script>

<template>
    <main class="app">
        <div class="infinite-progress" v-if="isLoading"></div>
        <navbar-layout :appSidebarOpened="appSidebarOpened" />
        <sidebar-layout @app-sidebar-toggled="onAppSidebarToggled($event)" />
        <section class="app-section" @click="toggleAppNavigation(false)">
        <div id="app">
            <router-view/>
        </div>
        </section>
    </main>
</template>
